import { useState, useEffect } from 'react';
import { ListTypeEntry, useERC } from '../context/ListTypeEntriesProvider';
import { toast } from 'react-toastify';
import { useApiMutation } from '../apis/useApi';

export const useFetchListTypeEntries = (
    erc: string,
    sort?: string
): ListTypeEntry[] | null => {
    const { data, setData } = useERC();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const getListTypeEntries = useApiMutation<any, {}>(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/`,
        'get'
    );

    useEffect(() => {
        if (!erc || data[erc]) return;

        const fetchData = async () => {
            setLoading(true);
            setError(null);

            const params = {
                p_auth: (window as any)?.Liferay?.authToken,
                pageSize: 1000
            }

            if (sort) {
                Object.assign(params, { sort });
            }

            try {
                const response = await new Promise<ListTypeEntry[]>(
                    (resolve, reject) => {
                        getListTypeEntries.mutate(
                            {
                                data: {},
                                params,
                                url: erc + '/list-type-entries'
                            },
                            {
                                onSuccess: (responseData) => {
                                    if (responseData?.items) {
                                        resolve(responseData.items);
                                    } else {
                                        reject('No listTypeEntries available');
                                    }
                                },
                                onError: (error: any) => {
                                    toast.error(
                                        error?.response?.data?.message ||
                                            'An error occurred'
                                    );
                                    reject(error);
                                }
                            }
                        );
                    }
                );

                setData(erc, response);
            } catch (err) {
                setError('Failed to fetch data');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [erc]);

    if (loading) return null;
    if (error) return null;

    return data[erc] || null;
};
